// extracted by mini-css-extract-plugin
export var audioPlayer = "_ta-0";